<template>
  <div v-if="!pending">
    <h2 class="text-2xl -mt-4 md:mt-2 mb-6 md:block md:text-left innerTransition__title">
      {{ t("getStarted.healthAndWellness.chooseTopic") }}
    </h2>

    <div class="bg-white divide-y-2 rounded-lg shadow-default overflow-hidden innerTransition__container">
      <CommonRippleBox ripple-position="center-left" :initial-opacity="0.9" class="rounded-none">
        <NuxtLinkLocale
          :locale="switchBlogLocale()"
          to="/tests/health-and-wellness"
          class="p-5 py-6 flex flex-row flex-nowrap items-center gap-2"
        >
          <BaseTypography variant="span" class="flex-1 font-semibold">
            {{ t("getStarted.healthAndWellness.allHealthAndWellnessTests") }}
          </BaseTypography>
          <NuxtImg src="/icons/mask.svg" alt="mask icon" width="30" height="30" />
        </NuxtLinkLocale>
      </CommonRippleBox>
      <CommonRippleBox
        v-for="category in categories"
        :key="category.slug"
        ripple-position="center-left"
        :initial-opacity="0.9"
        class="rounded-none"
      >
        <NuxtLinkLocale
          :locale="switchBlogLocale()"
          :to="`/tests/health-and-wellness?categories=${category.slug}`"
          class="p-5 py-6 flex flex-row flex-nowrap items-center gap-2"
        >
          <BaseTypography variant="span" class="flex-1 font-semibold">{{ category.title }}</BaseTypography>
          <NuxtImg src="/icons/mask.svg" alt="mask icon" width="30" height="30" />
        </NuxtLinkLocale>
      </CommonRippleBox>
    </div>
  </div>

  <div v-else class="w-full h-96 flex justify-center items-center">
    <NuxtImg class="w-20" src="/icons/loading.svg" />
  </div>
</template>

<script setup lang="ts">
import type { HealthAndWellnessCategory } from "../types";

const { t } = useI18n();
const pending = ref(true);
const categories = ref<HealthAndWellnessCategory[]>([]);

onMounted(async () => {
  const categoriesResults = await useFetchSubCategoryLists("health-and-wellness");
  categories.value = categoriesResults ?? [];
  pending.value = false;
});
</script>
